// extracted by mini-css-extract-plugin
export default {"header":"SummaryHeader_header__SP8YT"};